<template>
  <div>
       <!--采购报表-->
      <Card :bordered="false" dis-hover>
          <p slot="title">{{detailtext}}</p>
          <ButtonGroup shape="circle" slot="extra">
              <Button type="error" disabled v-if="purchase.status==3">
                  已撤销
              </Button>
              <Button type="error" v-else @click="RevokeFn()">
                  撤销
              </Button>
              <Button type="primary" @click="point()">
                  打印
              </Button>
              <Button type="success" @click="alsoOpenorder">
                  再次采购
              </Button>
          </ButtonGroup>
          <img src="../../assets/img/chexiao.png" class="RevokeImg" v-if="purchase.status==3">
          <Row>
              <Col span="8"><strong>供应商：</strong> <span class="result">{{purchase.suppliername}}</span></Col>
              <Col span="8"><strong>结算账户：</strong> <span class="result">{{bankFields.bankname}}</span></Col>
              <Col span="8"><strong>本单欠款：</strong> <span class="result">{{purchase.nomoney}}</span></Col>
              <Col span="8"><strong>门店：</strong> <span class="result">{{doorname}}</span></Col>
              <Col span="8"><strong>商品金额：</strong> <span class="result">￥{{purchase.money}}</span></Col>
              <Col span="8"><strong>往期欠款：</strong> <span class="result">{{purchase.lastNomoney}}</span></Col>
              <Col span="8"><strong>开单人：</strong> <span class="result">{{purchase.adminName}}</span></Col>
              <Col span="8"><strong>商品数量：</strong> <span class="result">{{purchase.total}}</span></Col>
              <Col span="8"><strong>合计欠款：</strong> <span class="result">{{purchase.totalNomoney}}</span></Col>
              <Col span="8"><strong>单据编号：</strong> <span class="result">{{purchase.purchasecode}}</span></Col>

              <Col span="8"><strong>实付金额：</strong> <span class="result">￥{{purchase.paymoney}}</span></Col>
              <Col span="8"><strong>业务日期：</strong> <span class="result">{{purchase.time}}</span></Col>
              <Col span="24"><strong>备注：</strong> <span class="result">{{purchase.remark}}</span></Col>
          </Row>
      </Card>
      <table  class="ive-table" v-for="(item, index) in purchase.pgoods" :key="index">
          <thead>
              <th>商品详情</th>
              <th>名称/货号</th>
              <th>规格/颜色</th>
              <th>单价</th>
              <th>数量</th>
              <th>小计</th>
          </thead>
          <tbody>
          <tr align="center" v-for="(k,v) in purchase.pgoods[index].goodsItem" :key='v'>
              <td width="300" :rowspan="v" v-if="v==0">
                  <Fy-Img
                          class="img"
                          :ImgSrc="item.goodsimg | filtImg(item.goodsimg )"
                          :Width="100"
                          :Height="100"
                  ></Fy-Img>
              </td>
              <td>{{item.goodsname}} / {{item.goodscode}}</td>
              <td>{{k.size}} / {{k.color}}</td>
              <td>{{k.cprice}}</td>
              <td>{{k.quantity}}</td>
              <td>{{(k.cprice*k.quantity).toFixed(2)}}</td>
              <!-- <td :rowspan="v" v-if="v==0" >-&#45;&#45;&#45;&#45;</td>-->
          </tr>

          </tbody>
      </table>
       <div id="qrcodebox" style="display:none"></div>
       <div id="wetTwoCode" style="display:none"></div>
  </div>
</template>
<script>
    import {getLodop} from '@js/LodopFuncs'
    import QRCode from 'qrcodejs2'  
export default {
  data() {
    return {
        cid:'',
        sid:'',
        purchase:{},
        bankFields:{},
        doorname:JSON.parse(localStorage.getItem('shop')).name,
        detailtext:"详情",
        inferiorFlag:0,

    };
  },
    created: function() {
        //获取用户信息
        this.cid= JSON.parse(localStorage.getItem('shop')).cid
        this.sid = JSON.parse(localStorage.getItem('shop')).id
        this.getPurchaseId(this.$route.query.id)
    },
    
  methods: {
      //获取采购单
      getPurchaseId(id){
          this.$Api.getPurchaseId({
               id:id
          }).then(res => {
              if(res.code==200){
                  this.purchase = res.data
                  this.bankFields = res.data.bankFields
                  this.inferiorFlag = this.purchase.inferiorFlag
                  if(this.purchase.status==2){
                      this.detailtext="采购单详情"
                  }else if(this.purchase.status==4){
                    if(this.purchase.inferiorFlag==0){
                        this.detailtext="采购退换详情"
                    }else{
                        this.detailtext="采购残次品退换详情"
                    }
                  }else if(this.purchase.status==3){
                    if(this.purchase.inferiorFlag==1){
                        this.detailtext="采购残次品撤销单详情"     
                    }
                  }

                //  生成小程序与模板二维码 
                 document.getElementById("qrcodebox").innerHTML=''
                 document.getElementById("wetTwoCode").innerHTML=''
                 new QRCode('qrcodebox', {  
                    width: 100,  
                    height: 100,  
                    text: this.purchase.qrcode   
                 })  
                 new QRCode('wetTwoCode', {  
                    width: 100,
                    height: 100,
                    text: this.purchase.wetTwoCode  
                 })  
              }else {
                  this.$Message.warning(res.msg);
              }
          });

      },
      //采购撤销功能
      RevokeFn(){
          var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
          if(!PermisCode.includes('108')){
              this.$Message.warning('暂无权限');
              return
          }
          this.$Api.returnPurchase({
              purchaseId:this.$route.query.id,
              adminId:JSON.parse(localStorage.getItem('adminUser')).id,
              inferiorFlag:this.inferiorFlag,
          }).then(res => {
              if(res.code==200){
                  this.$Message.success('撤销成功');
                  this.getPurchaseId(this.$route.query.id)
              }else {
                  this.$Message.warning(res.msg);
              }
          });
      },
      //再次采购
       alsoOpenorder(){
           var idsstr=''
           this.purchase.pgoods.forEach(data=>{
               idsstr+=data.goodsid+','
           })
           this.$Api.selectGoodsIsShows({
               ids:idsstr
           }).then(res => {
               if(res.code==200){
                   if(res.data.length>0){
                       this.$Message.warning('已有商品被禁用，不能再次开单');
                       return
                   }
                   this.hreffn()
               }else {
                   this.$Message.warning(res.msg);
               }

           }).catch( (err)=> {
               this.$Message.warning(err.msg);
           });
       },
      hreffn() {
          this.purchase.pgoods.forEach((item)=>{
              let allNums = 0;
              item.id = item.goodsid;
              item.goodsItem.forEach((item)=>{
                  item.nums = item.quantity
                  allNums += item.nums;
              })
              item.nums = allNums;
          })
          sessionStorage.setItem('openaddpurc',JSON.stringify(this.purchase))
          var localcionurl=''
          if(this.purchase.status==2||this.purchase.status==3){
              localcionurl='/addpurc'
          }else if(this.purchase.status==4){
              localcionurl='/purchasea-tui'
          }
          this.$router.push({path:localcionurl,query:{
                  type:1
              }
          })

      },

      /**
       * 打印
       * */
      point(){
          //打印类型   4=80  5=110  1，2,3=针式
          var resultPrint = this.common.isSelectPrint(this,localStorage.getItem('setpointSize'))
          //是否选择的云打印机  
          var resultPrintCloud = this.common.isSelectPrint(this,localStorage.getItem('yuntext'))
          if(!resultPrint||resultPrint==''||resultPrint=='null'|| resultPrint=='undefined'){
              return;
          }
          if(resultPrintCloud != "" && resultPrintCloud != "null" && resultPrintCloud != null){ //云打印机
              /**
               ** cid,
               * sid,
               * 订单id
               * 打印机设备码
               * 类型
               * 标题
               **/
              let isEasy = JSON.parse(localStorage.getItem('shop')).isEasy
              let isTable = JSON.parse(localStorage.getItem('shop')).isTable
              let selectPaper = JSON.parse(localStorage.getItem('setpointSize'))
              if(selectPaper == 5){
                  selectPaper = "110mm";
              }else if(selectPaper == 4){
                  selectPaper = "80mm";
              }else if(selectPaper == 1 || selectPaper == 2 || selectPaper == 3){
                  selectPaper = "针式";
              }else{
                  this.$Message.warning("请到右上角点击用户进入个人中心设置打印类型");
                  return false;
              }
              this.common.CloudPrint(
                  this,this.cid,this.sid,this.$route.query.id,resultPrintCloud,
                  0, this.detailtext.replace("详情",""),isEasy,selectPaper,
                  isTable
                  )
              return;
          }  

          var LODOP = getLodop();
          /**
           * result返回值说明
           * 123 - 针式打印机的等分选择
           * 4   -   80MM的打印机
           * 5   -   110MM的打印机
           * **/


          //标题
          var orderType='' 
          if(this.purchase.status==2){
              orderType=JSON.parse(localStorage.getItem('shop')).name+'采购单'
          }else if(this.purchase.status==4) {
              orderType=JSON.parse(localStorage.getItem('shop')).name+'采购退换单'
          }
          
          //客户：
          var username= this.purchase.suppliername
          //销售员
          var adminName = this.purchase.adminName
          //制单员
          var zdName= JSON.parse(localStorage.getItem('adminUser')).name 
          //单号：
          var markcode = this.purchase.purchasecode
          //业务日期
          var zdtime = this.purchase.time
             
          //模板返回数据
          var resData = ''
          this.purchase.printNames.forEach(item=>{
               resData = resData+'<div style="display:inline-block;width:49%">'+item+'</div>'
          })
           
          //联系方式
          var phone = JSON.parse(localStorage.getItem('shop')).phone
          //联系地址：
          var lxaddress= JSON.parse(localStorage.getItem('shop')).address 
          //商品金额
          var countmoney = this.purchase.money
          //商品总件数
          var count=this.purchase.total
          //温馨提示
          var printRemark=this.purchase.printRemark
          if(printRemark==null){
              printRemark=''
          }else{
               printRemark='<li>温馨提示：'+printRemark+'</li>'
          }
           
           //模板二维码
            var qrcoderemark = this.purchase.qrcoderemark
            var qrcodeImg = document.getElementById("qrcodebox").getElementsByTagName('img')[0]
            var qrcoresult=''
           if(qrcoderemark==null){
                qrcoresult=''
           } else{
               qrcoresult ='<div><img src='+qrcodeImg.src+'  /><p>'+qrcoderemark+'</p></div>'
           }
           //小程序二维码  
           var wetTwoCode = document.getElementById("wetTwoCode").getElementsByTagName('img')[0]
           var getwetTwoCode = this.purchase.wetTwoCode
           if(getwetTwoCode==null){
                getwetTwoCode=''
           }else{

               getwetTwoCode='<div><img src='+wetTwoCode.src+' /><p>商城</p></div>'

           }

          var strTr=''
          this.purchase.pgoods.forEach((item,index)=>{
              item.goodsItem.forEach((k,v)=>{
                  strTr=strTr+'<tr><td>'+item.goodsname+'/'+item.goodscode+'</td><td id="spacing">'+k.size+'/'+k.color+'</td><td id="spacing">'+k.quantity+'</td><td id="spacing">'+k.cprice+'</td><td id="spacing">'+k.cprice*k.quantity+'</td></tr>'
              })
          })
          var strTable='<table><tr><td style="width: 26%">商品/货号</td><td style="width: 26%">规格/颜色</td><td >数量</td><td >金额</td><td >小计</td></tr>'+strTr+'</table>';
          var strStyles=''



          // 如果resultPrint==1 2 3 添加针式打印机样式，别问为啥，就这样做
          if( resultPrint==1 || resultPrint==2 || resultPrint==3 ){
              strStyles=""
              strStyles="<style>table tr td{border: 1pt solid #000000; border-collapse:collapse;}#count{border: 1pt solid #000000; border-top: 0;width: 95.8%; margin-left: 1.5pt} </style>"
          }else {
              strStyles=''
          }
          var strStyle="<style>*{margin: 0;padding: 0;} #contentse{font-size: 9pt;}#title{font-size: 16pt;text-align: center}table{width: 100%;margin-top: 5pt}" +
              "table tr td{height: 16pt;border-top:1pt #000000 dashed;white-space:normal; word-break:break-all;padding-right: 5pt}#title{ text-align: center; padding-top: 10pt; }" +
              ".list {list-style: none;  line-height: 10pt; }" +
              "#zds{width: 100%; margin:10pt auto;height: 50pt;text-align: center}" +
              ".codebox{width: 100%;}.codebox div{display:inline-block;width:50%;text-align:center}.codebox div img{display:block;margin:10pt auto}" +
              "#count{padding:5pt 10pt 5pt 0;margin-bottom: 5pt; border-top:1pt #000000 dashed;border-bottom:1pt #000000 dashed;}</style>"
          
          //获取当前的时间
          var time=LODOP.FORMAT("TIME:yyyy-mm-dd hh:mm:ss","now");
          var str=strStyle+strStyles+'<section id="contentse"><p id="title">'+orderType+'</p> ' +
              '<ul class="list">' +
              '<li>客户：'+username+'</li>' +
              '<li>销售员：'+adminName+'</li>' +
              '<li>制单员：'+zdName+'</li>' +
              '<li>单号：'+markcode+'</li>' +
              '<li>业务日期：'+zdtime+'</li>' +
              '</ul>'+
              strTable+
              '<p id="count">合计：'+count+'<span style="float:right;padding-right: 20pt">商品金额：RMB '+countmoney+'</span></p>'+
               resData+
              '<ul class="list">'+ 
              '<li>打印时间：'+time+'</li>' +
              '<li>联系方式：'+phone+'</li>' +
              '<li>联系地址：'+lxaddress+'</li>' +printRemark +
              '</ul>'+ 
              '<div class="codebox">'+qrcoresult+getwetTwoCode+'</div>' +
              '<p id="zds">掌大师,轻松管理每一天,客服热线:400-801-6580<br>下载即可使用的进销存</p></section>'
              this.Printing(LODOP,str)
      },

  }
};
</script>

<style lang="scss" scoped>
  .form-title{

    line-height: 54px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
  }
.result{
    display: inline-block;
    margin-bottom: 15px;
}
  .ive-table{
      margin-top: 20px;
      width: 100%;
      border-collapse: collapse;
      th{
          background: #bfdeff;
          padding: 10px;
      }
      tr td{
          border: 1px solid #ececec;
          padding: 10px;
      }
  }
</style>